<svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M8.385 2.09998L7.27075 2.74329L9.73759 7.01597L9.40591 6.86274C8.83079 6.60092 8.15634 6.64445 7.61601 6.97876L4.88818 8.68939L13.3735 17.1747L14.5341 15.3238L16.1026 18.0405L17.2168 17.3972L8.385 2.09998ZM13.7599 13.9829L10.9033 9.03503L8.81393 8.11141C8.65235 8.04121 8.47075 8.05542 8.32751 8.14716L7.07751 8.93363L13.1292 14.9853L13.7599 13.9829Z"
    fill="#333333" />
  <path
    d="M14.3297 9.85773L16.3482 7.83921L14.2236 5.71467L12.7744 7.16393L12.0674 5.93947L14.237 3.7699L18.293 7.82584L15.0366 11.0822L14.3297 9.85773Z"
    fill="#333333" />
  <path
    d="M9.70366 13.5179L6.49884 16.7227L5.14269 16.92L5.33356 15.5575L5.34 15.5639L8.54483 12.3591L9.70366 13.5179Z"
    fill="#333333" />
</svg>
  